import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setAuthToken } from '../lib/api';

/**
 * Keeps the axios auth token in sync with Clerk's session token.
 */
export function AuthTokenSync() {
  const { getToken, isSignedIn } = useAuth();

  useEffect(() => {
    if (!isSignedIn) {
      setAuthToken(null);
      return;
    }

    const syncToken = async () => {
      const token = await getToken();
      setAuthToken(token);
    };

    syncToken();

    // Refresh token every 50 minutes (Clerk tokens expire in 60min)
    const interval = setInterval(syncToken, 50 * 60 * 1000);
    return () => clearInterval(interval);
  }, [isSignedIn, getToken]);

  return null;
}
